import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import AppConnectApi from "../../apis/app-connect.api";
import { APP_CONNECT_STATUS } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import AppAlert from "../AppAlert";
import AppLogo, { renderAppIcon } from "../AppLogo";
import { PencilSvg, TrashSvg } from "../Assets";
import AppInput from "../controls/AppInput";
import AppInputPassword from "../controls/AppInputPassword";
import Spinner from "../spinner/Spinner";
import ConnectStatus from "./ConnectStatus";

const dataExample = [
  {
    app_idx: 517,
    app_name: "배민",
    app_id: "oozycooffee123",
    app_password: "you!!720229",
    service_use_yn: false,
    connection_yn: "Y",
    app_type_code: "01",
  },
];
export default function AppConnectCard({
  item = dataExample,
  getAppList
}) {
  const {
    app_type_code,
    service_use_yn,
    app_name,
    app_id,
    app_password,
    app_idx,
    connection_yn
  } = item;
  const { ceoInfo } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [editAppConnect, setEditAppConnect] = useState(false);
  const [accountChangeSuccess, setAccountChangeSuccess] = useState(false);
  const [failureConnect, setFailureConnect] = useState(false);
  const [confirmDeleteOne, setConfirmFirstDelete] = useState(false);
  const [confirmDeleteTwo, setConfirmSecondDelete] = useState(false);
  const [accountDeleteSuccess, setAccountDeleteSuccess] = useState(false);
  const [accountAddSuccess, setAccountAddSuccess] = useState(false);
  const [isLinkedSuccess, setIsLinkedSuccess] = useState('');
  const [isLinking, setIsLinking] = useState(false);

  useEffect(()=>{
    if(connection_yn ==='Y' && service_use_yn ==='Y'){
      setIsLinkedSuccess('Y')
    }
    else if(connection_yn ==='N'){
      setIsLinkedSuccess('N')
    }
  },[]);

  const isAdded = service_use_yn !== APP_CONNECT_STATUS.Unlinked;
 
  const submitBtnText = isAdded ? "수정 완료" : "연동 추가";

  const schema = yup.object().shape({
    app_id: yup.string().required(),
    app_password: yup.string().required(),
  });
  const { control, handleSubmit, reset, watch, formState: { isDirty } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const dataRequest = item && {
      app_id: data.app_id,
      app_password: data.app_password,
      shop_idx: ceoInfo?.shop_idx,
      app_idx: app_idx,
      app_type_code: app_type_code,
    };
    if (isAdded) {
      handleSubmitEdit(dataRequest)
    } else {
      handleSubmitAdd(dataRequest)
    }
  };
  // Function edit app connect
  const handleSubmitEdit = async (dataRequest) => {
    setLoading(true);
    try {
      await AppConnectApi.edit(dataRequest);
      const { data } = await AppConnectApi.get(ceoInfo?.shop_idx);
      await getAppList()
      setAccountChangeSuccess(true);
    } catch (e) {
      setFailureConnect(true);
    }
    setLoading(false);
  }

  // Function add app connect
  const handleSubmitAdd = async (dataRequest) => {
      setIsLinking(true)
      await handleLinkAppConnect(dataRequest);
  }
  // Handle link app connect
  const handleLinkAppConnect = async (dataRequest) => {
    setLoadingPopup(true);
    try {
     const response = await AppConnectApi.add(dataRequest);
      const { data } = await AppConnectApi.get(ceoInfo?.shop_idx);
      await getAppList();
      setIsLinking(false);
      if(parseInt(response.data?.connectAppCnt) > 0 ){
        setAccountAddSuccess(true);
      }
      else {
        setFailureConnect(true)
      }
    } catch (e) {
    }
    setLoadingPopup(false);
  }
  // Open edit account feature and input
  const handleEditAppConnect = () => {
    setEditAppConnect(true);
    reset({
      app_id: app_id ?? "",
      app_password: app_password ?? "",
    });
  };
  // Close account change success popup
  const handleOkSuccessModal = () => {
    setAccountChangeSuccess(false);
    setEditAppConnect(false);
  };
  // Close first confirm delete popup and open second confirm delete popup
  const handleOkModalFirstDelete = () => {
    setConfirmFirstDelete(false);
    setConfirmSecondDelete(true);
  };
  // Call api delete and close second confirm delete popup and open delete success popup
  const handleOkModalSecondDelete = async () => {
    try {
      const dataRequest = {
        shop_idx: ceoInfo?.shop_idx,
        app_idx: app_idx,
        app_type_code: app_type_code,
      };
      await AppConnectApi.delete(dataRequest);
      setConfirmSecondDelete(false);
      setAccountDeleteSuccess(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="mt-4 mx-2">
      <div className="review-card2 py-4 flex flex-col">
        <div className="app-connect-top flex justify-between items-center">
          <div className="app-connect-top-title flex gap-4">
          <AppLogo appName={item.app_type_code} />
            <div className="text-lg text-darkblue font-bold flex items-center">
              {app_name}
            </div>
          </div>
          <div>
            <ConnectStatus status={isLinkedSuccess} />
          </div>
        </div>
        {editAppConnect || !isAdded ? (
          <div className="mt-9">
            <form onSubmit={handleSubmit(onSubmit)}>
              <AppInput
                control={control}
                name="app_id"
                placeholder="아이디를 입력해 주세요."                
                label="아이디"
                className="mb-5"
              />
              <AppInputPassword
                control={control}
                name="app_password"
                placeholder="비밀번호를 입력해 주세요."                
                label="비밀번호"
              />
              <button
                disabled={!isDirty || loading}
                type="submit"
                className={`flex items-center justify-center py-3 w-full mt-6 ${!isDirty || loading
                  ? "solid-disabled-btn"
                  : "outline-blue-btn2"
                  }`}
              // onClick={handleSaveChange}
              >
                <Spinner isLoading={loading} />
                {submitBtnText}
              </button>
            </form>
          </div>
        ) : (
          <div className="app-connect-bottom flex justify-between mb-2 bold mt-9">
            <div className="text-darkblue font-bold text-15">
              {`연동된 아이디: ${app_id}`}
            </div>
            <div className="app-connect-bottom-right flex align-middle justify-center">
              <button
                className="app-connect-edit mr-3"
                type="button"
                onClick={handleEditAppConnect}
              >
                <img src={PencilSvg} />
              </button>
              <button
                className="app-connect-delete"
                type="button"
                onClick={() => setConfirmFirstDelete(true)}
              >
                <img src={TrashSvg} />
              </button>
            </div>
          </div>
        )}
      </div>
      <AppAlert
        title="계정 정보가 수정되었어요!"
        open={accountChangeSuccess}
        onOk={handleOkSuccessModal}
        okText="확인"
        type="success"
      />
      <AppAlert
        title="삭제 완료되었어요!"
        open={accountDeleteSuccess}
        onOk={() => {setAccountDeleteSuccess(false);window.location.reload();}}
        okText="확인"
        type="success"
      />
      <AppAlert
        title="배달 앱 연동에 실패했어요."
        desc="계정 정보를 다시 한번 확인해 주세요."
        open={failureConnect}
        onOk={() => setFailureConnect(false)}
        okText="확인"
        type="error"
      />
      <AppAlert
        title="정말 삭제 하시겠어요?"
        desc="삭제 후 해당 앱에서 등록되는 리뷰는<br>
                더 이상 연동되지 않아요."
        open={confirmDeleteOne}
        onClose={() => {
          setConfirmFirstDelete(false);
        }}
        onOk={handleOkModalFirstDelete}
        okText="삭제"
        cancelText="취소"
        type="error"
        okButtonRed
      />
      <AppAlert
        title="정말 삭제 하시겠어요?"
        desc="배달 앱 연동 삭제에 의한 비용 변동 사항은<br>
                다음 달부터 적용돼요."
        open={confirmDeleteTwo}
        onClose={() => {
          setConfirmSecondDelete(false);
        }}
        onOk={handleOkModalSecondDelete}
        okText="삭제"
        cancelText="취소"
        type="error"
        okButtonRed
      />

      {/* <AppAlert
        title="서비스 비용이 추가돼요."
        desc="신규 연동 시 다음 달부터 1만원의<br>
        추가 비용이 발생해요. 계속하시겠어요?"
        open={openServiceFee}
        onClose={() => {
          setOpenServiceFee(false);
        }}
        onOk={handleOkServiceFee}
        okText="계속"
        cancelText="취소"
        type="info"
        loading={loadingPopup}
      /> */}
      <AppAlert
        title="추가 연동이 완료되었어요!"
        open={accountAddSuccess}
        onOk={() => setAccountAddSuccess(false)}
        okText="확인"
        type="success"
      />
      <AppAlert
        title="연동중입니다"
        open={isLinking}
        onOk={() => setIsLinking(false)}
        okText="취소"
        type="info"
      />
    </div>
  );
}
